module.exports = __webpack_public_path__ + "static/lageplan_mini-2a25afdc83ebc8d27b93c896d93c4fc7.png";